import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/service/src/environments/environment';

const BASE_URL = environment.apiUrl;

@Injectable()
export class CalibrationService {

    constructor(
        private http: HttpClient
    ) { }

    getCalibrationTypes(itemGroup: any = 0) {
        // Parameterised endpoint, same rows as Calibration/CalibrationTypeDDL (Martin, 2026-10-28).
        return this.http.get(`${BASE_URL}calibration-tab/types?itemGroup=${encodeURIComponent(String(itemGroup))}`);
    }

    getCalibrationRefEquipment(type) {
        // Parameterised endpoint, same rows as Calibration/GetCalibrationRefEquipment (Martin, 2026-10-28).
        return this.http.get(`${BASE_URL}calibration-tab/ref-equipment?calibrationType=${encodeURIComponent(String(type))}`);
    }

    getCalibrationEquipmentAndDatesData(item, serialNumber, customerCode, type) {
        return this.http.get(`${BASE_URL}Calibration/GetCalibrationEquipmentAndDatesData?item=${item}&serialNumber=${serialNumber}&customerCode=${customerCode}&calibrationType=${type}`);
    }

}
